import { modalConfirmarStyles } from './ModalConfirmar.style'

export function modalConfirmarIO() {
  return {
    styles: modalConfirmarStyles
  }
}

export type ModalConfirmarIO = ReturnType<typeof modalConfirmarIO>
